import Icon from "./Icon";
import { Button } from "./TooltipControls";
import * as React from "react";
class ToolbarIcon extends React.PureComponent {
    render() {
        const { className, id, text, tooltip, icon, iconSet, pulse, spin, stroke, hollow, disabled, } = this.props;
        const placement = this.props.placement || "bottom";
        return (React.createElement(Button, { tooltip: tooltip, id: id, placement: placement, onClick: this.invokeAction, disabled: disabled, className: className },
            icon !== undefined ? (React.createElement(Icon, { set: iconSet, name: icon, pulse: pulse, spin: spin, stroke: stroke, hollow: hollow })) : null,
            text !== undefined ? React.createElement("div", { className: "button-text" }, text) : null,
            this.props.children));
    }
    invokeAction = (evt) => {
        const { instanceId, onClick } = this.props;
        if (onClick !== undefined) {
            evt.preventDefault();
            onClick(instanceId);
        }
    };
}
export default ToolbarIcon;
